<template>
    <div class="mb-5">
        <div class="header-section">
            <div class="d-flex justify-content-center text-center">
                📅 {{ event.name }} <br />({{ event.event_date | datetime }})
            </div>
        </div>
        <!-- <b-alert variant="success" show>
        <div class="d-flex justify-content-center text-center">📅 {{event.name}} <br />({{event.event_date | datetime}})</div>
      </b-alert> -->
    <b-tabs>
        <b-tab title="Registro">
            <div v-if="!personLoaded">
            <b-row>
                <b-col>Escanee el código QR de la invitación</b-col>
            </b-row>
            <b-row align-h="center">
                <b-col cols="12" lg="3">
                    <div class="border border-success rounded">
                        <qrcode-stream @decode="onDecode"></qrcode-stream>
                    </div>
                </b-col>
            </b-row>
            <b-row align-h="center" class="mt-3">
                <b-col cols="12" lg="3">
                    <app-form-input
                        placeholder="Código / Documento"
                        v-model="code"
                        type="number"
                        size="lg"
                    ></app-form-input>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col cols="12" lg="3">
                    <b-btn
                        @click="validateCode"
                        :disabled="busy"
                        block
                        variant="primary"
                        >Validar código / documento</b-btn
                    >
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col cols="12" md="3" class="mt-3">
                    <b-btn variant="secondary" block @click="$router.go(-1)"
                        ><i class="fas fa-times"></i> Cancelar</b-btn
                    >
                </b-col>
            </b-row>
        </div>
        <div v-else>
            <b-row v-if="!!todayEntries">
                <b-col>
                    <div class="error-toastr">
                        <h4 class="d-none d-md-block">
                            Esta persona ya tiene un ingreso registrado el día
                            de hoy
                        </h4>
                        <span class="d-md-none"
                            >Esta persona ya tiene un ingreso registrado el día
                            de hoy</span
                        >
                    </div>
                </b-col>
            </b-row>
            <b-row align-v="center">
                <b-col cols="12" md="3" lg="4">
                    <app-form-input
                        label="Nombre"
                        v-model="person.name"
                        @input="$v.person.name.$touch()"
                        :error="$v.person.name.$error"
                        required
                    ></app-form-input>
                </b-col>
                <b-col cols="12" md="3" lg="4">
                    <app-form-input
                        label="Documento"
                        v-model="person.document"
                        @input="$v.person.document.$touch()"
                        :error="$v.person.document.$error"
                        required
                    ></app-form-input>
                </b-col>
                <b-col cols="12" md="3" lg="4">
                    <app-form-input
                        label="E-mail"
                        v-model="person.email"
                        @input="$v.person.email.$touch()"
                        :error="$v.person.email.$error"
                        required
                    ></app-form-input>
                </b-col>
                <b-col cols="12" md="3" lg="4">
                    <app-form-input
                        label="Teléfono"
                        v-model="person.phone"
                    ></app-form-input>
                </b-col>
                <b-col cols="12" md="3" lg="4">
                    <app-form-checkbox
                        size="lg"
                        v-model="person.merchandiseDelivered"
                        switch
                        >Recibe kit o mercancia</app-form-checkbox
                    >
                </b-col>
                <b-col cols="12" class="mt-3">
                    <app-form-text-area
                        v-model="person.notes"
                        rows="3"
                        label="Notas / Observaciones"
                    ></app-form-text-area>
                </b-col>
            </b-row>
            <b-row align-h="end" class="mt-3 d-flex flex-wrap">
                <b-col cols="12" lg="2" class="d-none d-md-block mt-4">
                    <b-btn
                        block
                        @click="personLoaded = false"
                        variant="secondary"
                        ><i class="fas fa-times"></i> Cancelar</b-btn
                    >
                </b-col>
                <b-col cols="12" lg="2" class="order-sm-1 order-md-2 mt-4">
                    <b-btn block variant="confirm" @click="registerEntry"
                        ><i class="fas fa-save"></i> Registrar Ingreso</b-btn
                    >
                </b-col>
                <b-col cols="12" lg="2" class="d-md-none mt-4">
                    <b-btn
                        block
                        @click="personLoaded = false"
                        variant="secondary"
                        ><i class="fas fa-times"></i> Cancelar</b-btn
                    >
                </b-col>
            </b-row>
        </div>
        </b-tab>
        <b-tab title="Consulta">
            <app-event-entries-list
                :event="event"
            ></app-event-entries-list>
        </b-tab>
    </b-tabs>

    </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import { required, numeric, email } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import appEventEntriesList from "./EventEntriesList";

export default {
    components: {
        QrcodeStream,
        appEventEntriesList,
    },
    props: {
        // eventId: {
        //     type: Number,
        //     required: true,
        // },
        // eventName: {
        //     type: String,
        //     required: true,
        // },
        // eventDate: {
        //     type: String,
        //     required: true,
        // },
    },
    data: () => ({
        tone: null,
        errorTone: null,
        person: {
            id: '',
            name: '',
            document: '',
            email: '',
            phone: '',
            merchandiseDelivered: false,
        },
        todayEntries: 0,
        personLoaded: false,
        code: '',
        busy: false,
    }),
    validations: {
        person: {
            id: { required, numeric },
            name: { required },
            document: { required },
            email: { required, email },
        },
    },
    computed: {
        ...mapGetters({
            event: 'currentEvent',
        }),
    },
    methods: {
        async onDecode(val) {
            try {
                const {
                    data: { person, todayEntries },
                } = await this.$repo.post(
                    `events/${this.event.id}/validate-entry`,
                    { payload: val }
                )
                this.beep()
                this.todayEntries = todayEntries
                _.keys(this.person).map(
                    (key) => (this.person[key] = person[key])
                )
                this.personLoaded = true
            } catch ({ message }) {
                this.errorBeep()
                toastr.error(message)
            }
        },
        beep() {
            this.tone.play()
        },
        errorBeep() {
            this.errorTone.play()
        },
        async registerEntry() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                return toastr.error('Debe diligenciar los campos adecuadamente')
            }

            try {
                const { data } = await this.$repo.post(
                    `events/${this.event.id}/register-entry`,
                    this.person
                )
                toastr.success('Ingreso registrado satisfactoriamente')
                this.personLoaded = false
            } catch (error) {
                toastr.error(
                    'Ocurrió un error al registrar el ingreso, por favor intente de nuevo más tarde'
                )
            }
        },
        async validateCode() {
            if (!this.code)
                return toastr.error('Debe escribir un código válido')

            try {
                this.busy = true
                const {
                    data: { person, todayEntries },
                } = await this.$repo.post(
                    `events/${this.event.id}/validate-code`,
                    { code: this.code, eventId: this.event.id }
                )
                this.todayEntries = todayEntries
                _.keys(this.person).map(
                    (key) => (this.person[key] = person[key])
                )
                this.personLoaded = true
                this.code = ''
            } catch (error) {
                toastr.error(error)
            } finally {
                this.busy = false
            }
        },
    },
    created() {
        this.tone = new Audio('/sounds/beep-07a.mp3')
        this.errorTone = new Audio('/sounds/beep-10.mp3')
    },
}
</script>

<style scoped>
.error-toastr {
    background-color: #bd362f;
    border-radius: 6px;
    color: white;
    padding: 15px 10px;
    display: flex;
    align-items: center;
    margin: 10px 0;
}

.header-section {
    background-color: #ff8600;
    color: white;
    border-radius: 6px;
    padding: 15px 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
    font-size: 1.1rem;
}
</style>
